// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const modalStyles = css`
  .Modal-Header {
    top: 0;
    position: sticky;
    min-height: 54px;
    z-index: 10000;
  }
  .Modal_Heading {
    border-bottom: none;
    padding: 16px;
    font-size: 16px;
    justify-content: center;
    height: auto;
    margin-bottom: 0px;
    background-color: #f4f4f4;
    text-transform: lowercase;
    text-align: center;
  }
  .Modal_Heading:first-letter {
    text-transform: uppercase;
  }
  .TCPModal__InnerContent.shop-by-look-modal-inner-content {
    right: 0;
    left: auto;
    transform: none;
    box-shadow: 0 4px 8px 0 rgba(163, 162, 162, 0.5);
    padding: 0px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    animation: fade-slide-in 0.5s ease-out;
    border-radius: 16px 16px 0 0;
    top: auto;
    bottom: 0;
    height: 70%;
    @media ${(props) => props?.theme.mediaQuery.mediumMax} {
      height: 50%;
    }
    @keyframes fade-slide-in {
      0% {
        transform: translateY(100%);
        opacity: 0;
      }
      100% {
        transform: translateY(5%);
        opacity: 1;
      }
    }
  }
  .TCPModal__InnerContent::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  .close-modal {
    top: 14px;
    height: 16px;
    width: 16px;
  }
  @media ${(props) => props?.theme.mediaQuery.mediumMax} {
    .Modal_Heading {
      display: block !important;
    }
  }
`;

export default modalStyles;
